import React from 'react';
import { useSelector } from 'react-redux';

import { CheckmarkAnimation } from '@eika/checkmark-animation';
import { Link, LinkType } from '@eika/link';

import { getSkadedetaljerUrl } from '../../components/kvittering/kvittering-utils';
import CustomerFeedbackLink from '../../components/sporreskjema-button/customer-feedback-link';
import { useConfig } from '../../config';
import { useKunde } from '../../kundeinfo/kunde-context';
import { AppState } from '../../reducers';
import { useWindowScrollTop } from '../../sporsmalsflyt/hooks';
import { validateFodselsnummer } from '../../sporsmalsflyt/validation/validate';

import './ettersending-kvittering.scss';

export const EttersendingKvittering = () => {
    const { skadesakExists, skadenummer } = useSelector((state: AppState) => state.ettersending);
    const { minside, folgskade } = useConfig().links;
    const { kundeinfo } = useKunde();
    const windowScrollTop = useWindowScrollTop();
    windowScrollTop();

    return (
        <article className="ettersending-kvittering">
            <div className="ettersending-kvittering__checkmark-wrapper">
                <CheckmarkAnimation />
            </div>
            <h1 className="typography-h1__light">Skadesaken er oppdatert</h1>
            <p>
                En skadebehandler vil se på saken så raskt som mulig. Hvis vi trenger mer informasjon tar vi kontakt med
                deg.
            </p>
            <p>Du kan ikke se ettersendte dokumenter på skadesaken din.</p>
            <div className="ettersending-kvittering__links">
                {skadesakExists && skadenummer && validateFodselsnummer(kundeinfo.offentligId) && (
                    <Link
                        href={getSkadedetaljerUrl(folgskade.url, skadenummer)}
                        linkType={LinkType.BUTTON_STANDARD_POSITIVE}
                    >
                        Til skadesaken
                    </Link>
                )}
                <Link href={minside.url}>Til forsikringsoversikten</Link>
            </div>
            <CustomerFeedbackLink />
        </article>
    );
};
